import { useQuery } from '@tanstack/react-query';
import { userManagementApi } from '@/lib/api/user-management';
import { FIVE_MINUTES_IN_MS } from '@/lib/constants';
import { userManagementQueryKeys } from '@/lib/query-keys/userManagement';

export const orgMemberQueryOptions = (userId: string) => ({
  queryKey: userManagementQueryKeys.userManagement.profile(userId),
  queryFn: async () => userManagementApi.getOrgUserById(userId),
  staleTime: FIVE_MINUTES_IN_MS,
});

export const useOrgMemberByIdQuery = (userId: string, enabled = true) => {
  return useQuery({
    ...orgMemberQueryOptions(userId),
    enabled: enabled && !!userId,
  });
};
